<mat-sidenav-container class="sidenav-container">
    <mat-sidenav #drawer position="start" class="sidenav" fixedInViewport="true" [attr.role]="isHandset ? 'dialog' : 'navigation'" [mode]="'over'">
        <mat-toolbar *ngIf="!isExtraccionistaModality()" class="sidenav-toolbar-side">
            <img class="image-menu-side" src="../../../assets/images/clayer-menu-side.png" />
        </mat-toolbar>
        <mat-nav-list>
            <mat-list-item *ngIf="isMenuVisible(medicalAppointment)" (click)="menuMedicalAppointmentTrigger.openMenu()">
                <div mat-line>Turnos</div>
                <button mat-icon-button #menuMedicalAppointmentTrigger="matMenuTrigger" [matMenuTriggerFor]="medicalAppointment">
          <mat-icon>more_vert</mat-icon>
        </button>
            </mat-list-item>
            <mat-divider></mat-divider>
            <mat-list-item *ngIf="isMenuVisible(admission)" (click)="menuAdmissionTrigger.openMenu()">
                <div mat-line>Admisión</div>
                <button mat-icon-button #menuAdmissionTrigger="matMenuTrigger" [matMenuTriggerFor]="admission">
          <mat-icon>more_vert</mat-icon>
        </button>
            </mat-list-item>
            <mat-divider></mat-divider>
            <mat-list-item *ngIf="isMenuVisible(cashCheck)" (click)="menuCashCheckTrigger.openMenu()">
                <div mat-line>Caja</div>
                <button mat-icon-button #menuCashCheckTrigger="matMenuTrigger" [matMenuTriggerFor]="cashCheck">
          <mat-icon>more_vert</mat-icon>
        </button>
            </mat-list-item>
            <mat-divider></mat-divider>
            <mat-list-item *ngIf="isMenuVisible(service)" (click)="menuServiceTrigger.openMenu()">
                <div mat-line>Servicio</div>
                <button mat-icon-button #menuServiceTrigger="matMenuTrigger" [matMenuTriggerFor]="service">
          <mat-icon>more_vert</mat-icon>
        </button>
            </mat-list-item>
            <mat-divider></mat-divider>
            <mat-list-item *ngIf="isMenuVisible(logistics)" (click)="menuLogisticsTrigger.openMenu()">
                <div mat-line>Logística</div>
                <button mat-icon-button #menuLogisticsTrigger="matMenuTrigger" [matMenuTriggerFor]="logistics">
          <mat-icon>more_vert</mat-icon>
        </button>
            </mat-list-item>
            <mat-divider></mat-divider>
            <mat-list-item *ngIf="isMenuVisible(medicalFee)" (click)="menuMedicalFeeTrigger.openMenu()">
                <div mat-line>Honorarios</div>
                <button mat-icon-button #menuMedicalFeeTrigger="matMenuTrigger" [matMenuTriggerFor]="medicalFee">
          <mat-icon>more_vert</mat-icon>
        </button>
            </mat-list-item>

            <mat-divider></mat-divider>
            <mat-list-item *ngIf="isMenuVisible(billing)" (click)="menuBillingTrigger.openMenu()">
                <div mat-line>Facturación</div>
                <button mat-icon-button #menuBillingTrigger="matMenuTrigger" [matMenuTriggerFor]="billing">
          <mat-icon>more_vert</mat-icon>
        </button>
            </mat-list-item>

            <mat-divider></mat-divider>
            <mat-list-item *ngIf="isMenuVisible(crm)" (click)="menuCrmTrigger.openMenu()">
                <div mat-line>CRM</div>
                <button mat-icon-button #menuCrmTrigger="matMenuTrigger" [matMenuTriggerFor]="crm">
          <mat-icon>more_vert</mat-icon>
        </button>
            </mat-list-item>
            <mat-divider></mat-divider>
            <mat-list-item *ngIf="isMenuVisible(configuration)" (click)="menuConfigurationTrigger.openMenu()">
                <div mat-line>Configuración</div>
                <button mat-icon-button #menuConfigurationTrigger="matMenuTrigger" [matMenuTriggerFor]="configuration">
          <mat-icon>more_vert</mat-icon>
        </button>
            </mat-list-item>
            <mat-divider></mat-divider>
            <mat-list-item *ngIf="canTest()" routerLink="/test-ml" (click)="drawer.close()">
                <div mat-line>Pruebas orden</div>
            </mat-list-item>
            <mat-divider></mat-divider>
            <mat-list-item (click)="drawer.close(); logOut()">
                <div mat-line>Cerrar sesión</div>
            </mat-list-item>

            <mat-divider></mat-divider>
        </mat-nav-list>

        <mat-menu #crm="matMenu">
            <button mat-menu-item *ngIf="isValidMenuTag('CRM_PACIENTE')" (click)="drawer.close()" routerLink="/patient-crm-search">
        Paciente
      </button>
        </mat-menu>

        <mat-menu #configuration="matMenu">
            <button mat-menu-item *ngIf="isValidMenuTag('CONFIGURACION_ESCANER')" (click)="drawer.close()" routerLink="/scanner-search">
        Scanner
      </button>
            <button mat-menu-item (click)="drawer.close()" routerLink="/printer-search">
        Impresora
      </button>
            <button mat-menu-item (click)="drawer.close()" routerLink="/study-report-template-search/1">
        Plantillas
      </button>

            <button *ngIf="txControlEnabled()" mat-menu-item (click)="drawer.close()" routerLink="/study-report-template-txcontrol-search/2">
        Plantillas TxControl
      </button>
        </mat-menu>

        <mat-menu #settingSeguridad="matMenu">
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_USUARIO')" [routerLink]="['/settings/usuario-lista/Usuarios']" mat-menu-item>
        Usuarios
      </button>
        </mat-menu>

        <mat-menu #settingServicio="matMenu">
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_CONSENTIMIENTO')" routerLink="/settings/consentimiento-lista/Consentimientos" mat-menu-item>
        Consentimientos
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_PREPARACION')" routerLink="/settings/preparacion-lista/Preparación" mat-menu-item>
        Preparación
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_SERVICIO')" routerLink="/settings/worklist-lista/Worklist" mat-menu-item>
        Worklist
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_SERVICIO')" routerLink="/settings/regla-informe-lista/Reglas informes" mat-menu-item>
        Reglas informes
      </button>
        </mat-menu>

        <mat-menu #settingReserva="matMenu">
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_AGENDA')" routerLink="/settings/agenda-lista/Agendas" mat-menu-item>
        Agendas
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_CONDICION')" routerLink="/settings/condicion-lista/Condiciones" mat-menu-item>
        Condiciones
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_FERIADO')" routerLink="/settings/feriado-lista/Feriados" mat-menu-item>
        Feriados
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_REGLAS')" routerLink="/settings/regla-agenda-lista/Reglas agenda" mat-menu-item>
        Reglas agenda
      </button>
            <button (click)="drawer.close()" mat-menu-item *ngIf="isValidMenuTag('CONFIGURACION_SUSPENSION_EQUIPO')" routerLink="/settings/suspension-equipo-lista/Suspension equipos">
        Suspension equipos
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_SUSPENSION_MEDICO')" routerLink="/settings/suspension-medico-lista/Suspension profesional" mat-menu-item>
        Suspension profesional
      </button>
            <button (click)="drawer.close()" mat-menu-item *ngIf="isValidMenuTag('CONFIGURACION_TRASLADO_EQUIPO')" routerLink="/settings/tiempo-traslado-centro-lista/Tiempo traslado centro">
        Tiempo traslado centro
      </button>
            <button (click)="drawer.close()" mat-menu-item *ngIf="isValidMenuTag('CONFIGURACION_TRASLADO_EQUIPO')" routerLink="/settings/tiempo-traslado-equipo-lista/Tiempo traslado equipo">
        Tiempo traslado equipo
      </button>
            <button (click)="drawer.close()" mat-menu-item *ngIf="isValidMenuTag('CONFIGURACION_TRASLADO_SERVICIO')" routerLink="/settings/tiempo-traslado-servicio-lista/Tiempo traslado servicio">
        Tiempo traslado servicio
      </button>
        </mat-menu>

        <mat-menu #settingfacturacionYcaja="matMenu">
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_HERRAMIENTA_COPIA_MASIVA')" routerLink="/settings/convenio-herramienta-actualizacion/Actualización de convenios" mat-menu-item>
        Actualización de convenios
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_HERRAMIENTA_COPIA_MASIVA')" routerLink="/settings/convenio-herramienta-cracion/Creando convenios" mat-menu-item>
        Creando convenios
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_CAJA')" routerLink="/settings/caja-lista/Cajas" mat-menu-item>
        Cajas
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_CONVENIO')" routerLink="/settings/convenio-lista/Convenios" mat-menu-item>
        Convenios
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_CORTE_FACTURACION')" routerLink="/settings/factura-corte-lista/Cortes facturación" mat-menu-item>
        Cortes facturación
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_PUNTO_VENTA')" routerLink="/settings/punto-venta-lista/Puntos de venta" mat-menu-item>
        Puntos de venta
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_FACTURACION_REGLA')" routerLink="/settings/regla-facturacion-lista/Reglas de facturación" mat-menu-item>
        Reglas de facturación
      </button>
            <button (click)="drawer.close()" *ngIf="
          isValidMenuTag('CONFIGURACION_HERRAMIENTA_REVALORIZACION_MASIVA')
        " routerLink="/settings/valorizacion-masiva/Valorización masiva" mat-menu-item>
        Valorización masiva
      </button>
        </mat-menu>

        <mat-menu #settingGeneral="matMenu">
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_CENTRO')" routerLink="/settings/centro-lista/Centros" mat-menu-item>
        Centros
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_CLIENTE')" routerLink="/settings/cliente-lista/Clientes" mat-menu-item>
        Clientes
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_ENTIDAD')" routerLink="/settings/entidad-lista/Entidades" mat-menu-item>
        Entidades
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_EQUIPO')" routerLink="/settings/equipo-lista/Equipos" mat-menu-item>
        Equipos
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_ENTIDAD')" routerLink="/settings/plan-lista/Planes" mat-menu-item>
        Planes
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_PRACTICA')" routerLink="/settings/practica-lista/Prácticas" mat-menu-item>
        Prácticas
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_PRACTICA_REGION')" routerLink="/settings/practica-region-lista/Prácticas región" mat-menu-item>
        Prácticas región
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_MEDICO')" routerLink="/settings/medico-lista/Profesionales" mat-menu-item>
        Profesionales
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_SECTOR')" routerLink="/settings/sector-lista/Sectores" mat-menu-item>
        Sectores
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_SERVICIO')" routerLink="/settings/servicio-lista/Servicios" mat-menu-item>
        Servicios
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_INSUMO')" routerLink="/settings/insumo-lista/Set insumos" mat-menu-item>
        Set insumos
      </button>
        </mat-menu>

        <mat-menu #settingHonorarios="matMenu">
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_HERRAMIENTA_COPIA_MASIVA')" routerLink="/settings/convenio-honorario-herramienta-actualizacion/Actualización honorarios" mat-menu-item>
        Actualización honorarios
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_CONVENIO')" routerLink="/settings/convenio-honorario-lista/Convenio honorarios" mat-menu-item>
        Convenio honorarios
      </button>
            <button (click)="drawer.close()" *ngIf="isValidMenuTag('CONFIGURACION_HERRAMIENTA_COPIA_MASIVA')" routerLink="/settings/convenio-honorario-herramienta-creacion/Creación honorarios" mat-menu-item>
        Creación honorarios
      </button>
        </mat-menu>

        <mat-menu #cashCheck="matMenu">
            <button mat-menu-item *ngIf="isValidMenuTag('CAJA_COBRANZA_PACIENTE')" (click)="drawer.close()" routerLink="/pending-cash-desk-search">
        Cobranza paciente
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('CAJA_NOTA_CREDITO_PACIENTE')" (click)="drawer.close()" routerLink="/made-cash-desk-search">
        Cobranzas realizadas
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('CAJA_COBRANZA_MANUAL')" (click)="drawer.close()" routerLink="/cash-desk-manual-search">
        Cobranza manual
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('CAJA_APERTURA_CIERRE')" (click)="drawer.close()" routerLink="/cash-desk-open-search">
        Apertura y cierre
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('CAJA_CONTROLA_CIERRE_CAJA')" (click)="drawer.close()" routerLink="/cash-desk-close-control-search">
        Control cierre caja
      </button>
        </mat-menu>

        <mat-menu #medicalAppointment="matMenu">
            <button mat-menu-item *ngIf="!isCT() && isValidMenuTag('TURNOS_ASIGNACION')" (click)="drawer.close()" routerLink="/reservation-wizard">
        Asignación
      </button>
            <button mat-menu-item *ngIf="isCT() && isValidMenuTag('TURNOS_ASIGNACION')" (click)="drawer.close()" routerLink="/reservation-ct-wizard">
        Asignación
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('TURNOS_CONSULTA')" (click)="drawer.close()" routerLink="/reservation-search">
        Consulta
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('TURNOS_CONSULTA_TURNO_INCONSISTENTE')" (click)="drawer.close()" routerLink="/reservation-inconsistent">
        Inconsistentes
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('TURNOS_CONFIRMACIONES')" (click)="drawer.close()" routerLink="/reservation-confirmation">
        Confirmaciones
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('TURNOS_RECITACIONES')" (click)="drawer.close()" routerLink="/admission-re-appointment">
        Recitaciones
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('TURNOS_ASIGNACION')" (click)="drawer.close()" routerLink="/medical-appointment-wait-search">
        Turnos en espera
      </button>

            <button mat-menu-item *ngIf="isValidMenuTag('TURNOS_CONSULTA')" (click)="drawer.close()" routerLink="/medical-appointment-auditing-search">
        Auditoría de turnos
      </button>
        </mat-menu>

        <mat-menu #admission="matMenu">
            <button mat-menu-item *ngIf="isValidMenuTag('ADMISION_ADMISION')" (click)="drawer.close()" routerLink="/admission-reception-search">
        Recepción
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('ADMISION_EXTRAORDINARIA')" (click)="drawer.close()" routerLink="/reservation-extraordinary-wizard">
        Admisión sin turno
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('ADMISION_ADMISION')" (click)="drawer.close()" routerLink="/reservation-pre-wizard">
        Admisión previa
      </button>

            <button mat-menu-item *ngIf="isValidMenuTag('ADMISION_ADMISION')" (click)="drawer.close()" routerLink="/integrated-reception-admission">
        Recepción integrada
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('ADMISION_EXTRAORDINARIA')" (click)="drawer.close()" routerLink="/integrated-extraordinary-admission">
        Admisión sin turno integrada
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('ADMISION_ADMISION')" (click)="drawer.close()" routerLink="/integrated-pre-admission">
        Admisión previa integrada
      </button>

            <button mat-menu-item *ngIf="isValidMenuTag('ADMISION_ADMISION')" (click)="drawer.close()" routerLink="/budget-search">
        Presupuesto
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('ADMISION_CONSULTA')" (click)="drawer.close()" routerLink="/admission-search">
        Consulta
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('ADMISION_CONSULTA')" (click)="drawer.close()" routerLink="/admission-integrated-search">
        Consulta integrada
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('ADMISION_LLAMADOR')" (click)="drawer.close()" routerLink="/caller">
        Llamador
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('ADMISION_LLAMADOR')" (click)="drawer.close()" routerLink="/orientation">
        Orientador
      </button>
        </mat-menu>

        <mat-menu #service="matMenu">
            <button mat-menu-item *ngIf="isValidMenuTag('SERVICIO_MEDICO_ATENCION_PACIENTE')" (click)="drawer.close()" routerLink="/medical-service-search">
        Atención paciente
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('INFORME_INFORMAR')" (click)="drawer.close()" routerLink="/study-report-search">
        Informar
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('INFORME_CONTROL')" (click)="drawer.close()" routerLink="/study-report-control-search">
        Control Informes
      </button>

            <button mat-menu-item *ngIf="isValidMenuTag('INFORME_CONTROL')" (click)="drawer.close()" routerLink="/laboratory-tubes-search">
        Control de muestras derivadas
      </button>
        </mat-menu>

        <mat-menu #logistics="matMenu">
            <button mat-menu-item *ngIf="isValidMenuTag('LOGISTICA_RECEPCION_ORDEN')" (click)="drawer.close()" routerLink="/receive-order-logistics-search">
        Recepción órdenes
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('LOGISTICA_ENVIO_ORDEN')" (click)="drawer.close()" routerLink="/send-order-logistics-search">
        Envio órdenes
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('LOGISTICA_ENVIO_INDIVIDUAL_ORDEN')" (click)="drawer.close()" routerLink="/send-individual-order-logistics">
        Envio individual ordenes
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('LOGISTICA_RECEPCION_INFORME')" (click)="drawer.close()" routerLink="/receive-study-report-logistics-search">
        Recepción informes
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('LOGISTICA_ENVIO_INFORME')" (click)="drawer.close()" routerLink="/send-study-report-logistics-search">
        Envio informes
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('LOGISTICA_ENVIO_INDIVIDUAL_INFORME')" (click)="drawer.close()" routerLink="/send-individual-study-report-logistics">
        Envio individual informes
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('LOGISTICA_ENTREGA_INFORME')" (click)="drawer.close()" routerLink="/study-report-delivery-search">
        Entrega de informes
      </button>
        </mat-menu>

        <mat-menu #billing="matMenu">
            <button mat-menu-item *ngIf="isValidMenuTag('FACTURACION_CONTROL_ORDEN')" (click)="findOrderControlDialg(); drawer.close()">
        Realizar control
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('FACTURACION_CONTROL_ORDEN')" (click)="drawer.close()" routerLink="/billing-close-search">
        Prefactuación
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('FACTURACION_GENERA_FACTURA')" (click)="drawer.close()" routerLink="/pre-billing-search">
        Generación factura
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('FACTURACION_GENERA_NOTA_CREDITO')" (click)="drawer.close()" routerLink="/billing-invoice-credit-search">
        Facturas y NC
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('FACTURACION_GENERA_FACTURA_MANUAL')" (click)="drawer.close()" routerLink="/billing-invoice-manual-search">
        Factura Manual
      </button>
        </mat-menu>

        <mat-menu #medicalFee="matMenu">
            <button mat-menu-item *ngIf="isValidMenuTag('MEDICO_HONORARIO_CONSULTA')" (click)="drawer.close()" routerLink="/medical-fee-search">
        Consulta
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('FACTURACION_CONTROL_LIQUIDACION')" (click)="drawer.close()" routerLink="/medical-fee-control-search">
        Control liquidación
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('FACTURACION_CONTROL_LIQUIDACION')" (click)="drawer.close()" routerLink="/medical-fee-pre-payment-search">
        Generar liquidación
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('FACTURACION_CONTROL_LIQUIDACION')" (click)="drawer.close()" routerLink="/medical-fee-payment-search">
        Consulta liquidación
      </button>
            <button mat-menu-item *ngIf="isValidMenuTag('FACTURACION_CONTROL_LIQUIDACION')" (click)="drawer.close()" routerLink="/medical-fee-payment-manual-search">
        Generar liquidación manual
      </button>
        </mat-menu>
    </mat-sidenav>

    <mat-sidenav #endSidenav position="end" class="end-side-nav" fixedInViewport="true" [mode]="'over'">
        <mat-toolbar class="sidenav-toolbar-side">
            <div class="full-width">
                <div class="pull-left">
                    <h2>{{ toolName }}</h2>
                </div>
                <div class="pull-right">
                    <button mat-icon-button (click)="endSidenav.close()">
            <mat-icon>close</mat-icon>
          </button>
                </div>
            </div>
        </mat-toolbar>
        <div class="tool-panel-container">
            <app-tool-panel-control #toolPanel></app-tool-panel-control>
        </div>
    </mat-sidenav>

    <mat-sidenav-content>
        <mat-toolbar *ngIf="!isExtraccionistaModality() && isLoggedIn() && isVisible()" class="sidenav-toolbar">
            <div class="menu-header">
                <div class="pull-left">
                    <button type="button" mat-icon-button (click)="drawer.toggle()">
            <mat-icon>menu</mat-icon>
          </button>
                    <!-- <img class="card-inline image-menu" src="../../../../Content/Images/clayer-menu.png"> -->
                    <img class="card-inline image-menu" src="../../../assets/images/clayer-menu.png" />
                </div>

                <div *ngIf="!isOldVersion()" class="pull-left version">
                    {{ getVersion() }}
                </div>

                <div *ngIf="!isOldVersion()" class="pull-left title-card-content">
                    <div class="menu-title">
                        <h1>{{ getMenuTitle }}</h1>
                        <div class="user-info">{{ getUserInfo }}</div>
                    </div>
                </div>

                <div *ngIf="isOldVersion()" class="pull-left old-version">
                    <span>Existe una nueva versión disponible, por favor recargue la
            pantalla</span
          >
        </div>

        <div
          class="avatar-card cursor-default pull-right"
          [matMenuTriggerFor]="login"
        >
          <div class="avatar-card-content">{{ getCardName }}</div>
        </div>
        <div class="pull-right">
          <app-video-chat-alert></app-video-chat-alert>
          <button
            matTooltip="Herramientas"
            [matMenuTriggerFor]="apps"
            mat-icon-button
          >
            <mat-icon>apps</mat-icon>
          </button>
        </div>
        <mat-menu #apps="matMenu">
          <button mat-menu-item (click)="openTool('MEDICAL_ORDEN_TRANSIT')">
            Control transito orden
          </button>
          <button mat-menu-item (click)="openTool('STUDY_REPORT_TRANSIT')">
            Control transito informe
          </button>
          <button
            mat-menu-item
            (click)="openTool('ORIENTATION_PATIENT_CALLER')"
          >
            Llamador paciente orientador
          </button>
          <button mat-menu-item (click)="openTool('FACTURACION_SCHEDULE_TASK')">
            Tareas programadas
          </button>
        </mat-menu>
        <mat-menu #login="matMenu">
          <button mat-menu-item (click)="logOut()">Cerrar sesión</button>
          <button mat-menu-item (click)="changePass()">
            Cambiar contraseña
          </button>
          <qrcode
            [qrdata]="getQRCode"
            [size]="256"
            [level]="'M'"
            usesvg="true"
          ></qrcode>
        </mat-menu>
      </div>
    </mat-toolbar>
    <div>
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
<!--
<div *ngIf="isExtraccionistaModality()">
  <router-outlet></router-outlet>
</div> -->